import React from "react";
import { useTranslation, Trans } from 'react-i18next';

const TrustSection = () => {
    const { t } = useTranslation();
    
    // Using objects from translation
    const pointsData = t('trustSection.points', { returnObjects: true }) || [];
    const trustPoints = Array.isArray(pointsData) ? pointsData : [];

    // Map icons manually to the translated points based on index
    const icons = [
        (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-primary">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                <path d="m9 12 2 2 4-4"/>
            </svg>
        ),
        (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-primary">
                <circle cx="12" cy="12" r="10"/>
                <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"/>
                <path d="M12 18V6"/>
            </svg>
        ),
        (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-primary">
                <rect width="18" height="11" x="3" y="11" rx="2" ry="2"/>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
        ),
        (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-red-500">
                <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/>
                <path d="M12 9v4"/>
                <path d="M12 17h.01"/>
            </svg>
        )
    ];

    return (
        <section aria-labelledby="trust-title" className="py-24 bg-black border-y border-glass-border relative overflow-hidden">
            <div className="container relative z-10">
                <div className="text-center mb-16">
                    <h2 id="trust-title" className="text-4xl md:text-5xl font-black mb-4 uppercase tracking-tighter text-white" data-aos="fade-up">
                        <Trans i18nKey="trustSection.title">
                            Trade safely with <span className="text-primary">Zaptopay</span>
                        </Trans>
                    </h2>
                    <p className="text-text-muted text-lg max-w-2xl mx-auto" data-aos="fade-up" data-aos-delay="100">
                        {t('trustSection.subtitle')}
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {trustPoints.map((point, index) => (
                        <div 
                            key={index}
                            className="glass p-8 flex flex-col items-start gap-4 hover:-translate-y-2 transition-transform duration-300 bg-white/5 border-white/10"
                            data-aos="fade-up"
                            data-aos-delay={index * 100}
                        >
                            <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-2">
                                {icons[index % icons.length]}
                            </div>
                            <h3 className="text-xl font-bold text-white m-0">{point.title}</h3>
                            <p className="text-text-muted text-sm leading-relaxed m-0">{point.desc}</p>
                        </div>
                    ))}
                </div>
                
                <div className="mt-16 flex flex-col items-center gap-8" data-aos="fade-up" data-aos-delay="400">
                    <div className="inline-flex items-center gap-2 bg-red-500/10 border border-red-500/20 text-red-400 px-4 py-2 rounded-lg text-sm font-semibold">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
                        </svg>
                        <span>{t('trustSection.supportWarning')}</span>
                    </div>

                    <button 
                        onClick={() => window.scrollTo({ top: document.getElementById('calculator')?.offsetTop - 100, behavior: 'smooth' })}
                        className="px-12 py-5 bg-[#00ff88] text-black font-black text-sm uppercase tracking-[0.2em] rounded-xl overflow-hidden shadow-[0_0_30px_rgba(0,255,136,0.4)] hover:shadow-[0_0_50px_rgba(0,255,136,0.6)] transition-all active:scale-95"
                    >
                        {t('trustSection.cta')}
                    </button>
                </div>
            </div>
        </section>
    );
};

export default TrustSection;
